import BlockText from "../../block-content/block-text";
import { Link } from "gatsby";
import styled from "styled-components";
import tw from "twin.macro";
import ButtonLink from "../button-link";

export default function SimpleBlock(props) {
  const simpleBlock = props.props ?? props.pageBlock;
  const PlainText = styled.div`
    a {
      ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
    }
    p {
      ${tw`mb-6`}
    }
    ul {
      list-style-type: disc;
      list-style-position: inside;
    }
    ol {
      list-style-type: decimal;
      list-style-position: inside;
    }
    ul ul, ol ul {
      list-style-type: circle;
      list-style-position: inside;
      margin-left: 15px;
    }
    ol ol, ul ol {
      list-style-type: lower-latin;
      list-style-position: inside;
      margin-left: 15px;
    }
  `;
  const hasTightSpacing = simpleBlock.hasTightSpacing;
  const TextStyles = PlainText;

  return (
    <section
      className={`${hasTightSpacing ? `my-5 md:my-12` : `my-10 md:my-24`} ${
        simpleBlock?.layout?.background?.gradient ? "bg-gradient" : ""
      }`}
    >
      <div className="simple-block max-w-6xl px-4 mx-auto">
        <div className="md:flex md:flex-wrap md:items-center">
          <div className="w-full lg:w-8/12 mx-auto">
            <TextStyles>
              <BlockText blocks={simpleBlock._rawBody} />
            </TextStyles>
            <ButtonLink
              label={simpleBlock.buttonText}
              link={simpleBlock.link}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
